import React from 'react'
import { I18n } from '@front/volcanion/'
import { TableCell } from '@mui/material'

import { MenuSelectorField, ModelMenuSelectorField, NumberField } from '@front/squirtle'

const Row = ({ currentTarget, isDisabled, disabledTargets, disableTarget, company }) => {

  return (
    <>
      <TableCell size={'small'}>
        <MenuSelectorField
          name='orderlimit.limit_type'
          options={[
            { label: I18n.t('order_limit.limit_type.warn'), value: 'warn' },
            { label: I18n.t('order_limit.limit_type.block'), value: 'block' }
          ]}
          selectFirst
          allowNone={false}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell size={'small'}>
        <NumberField
          name='orderlimit.limit_amount'
          type='float'
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
          allowNull
          minValue={0}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell size={'small'}>
        <NumberField
          name='orderlimit.limit_count'
          type='number'
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
          allowNull
          minValue={0}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell size={'small'}>
        <MenuSelectorField
          name='orderlimit.period'
          options={[
            { label: I18n.t('order_limit.period.monthly'), value: 'monthly' },
            { label: I18n.t('order_limit.period.weekly'), value: 'weekly' },
            { label: I18n.t('order_limit.period.daily'), value: 'daily' }
          ]}
          selectFirst
          allowNone={false}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell size={'small'}>
        <ModelMenuSelectorField
          name='orderlimit.payment_type'
          model_name={'paymenttype'}
          searchMode='search'
          labelKeys={['name_translated']}
          config={{
            initial_filter: { disabled: false },
            sort: ['display_index ASC']
          }}
          noneFirst
          selectFirst
          noneLabel={I18n.t('all')}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell size={'small'}>
        <NumberField
          name='priority'
          type='number'
          InputProps={{
            inputProps: { style: { textAlign: 'center' } }
          }}
          minValue={0}
          maxValue={99}
          disabled={isDisabled}
        />
      </TableCell>
      {!disableTarget && <TableCell size={'small'}>
        <MenuSelectorField
          name='target'
          disabledOptions={disabledTargets}
          options={[
            { label: I18n.t('company.label', { count: 1 }), value: 'company' },
            { label: I18n.t('contract.label', { count: 1 }), value: 'companycontract' },
            { label: I18n.t('companyservice.label', { count: 1 }), value: 'companyservice' },
            { label: I18n.t('companyuser.label', { count: 1 }), value: 'companyuser' }
          ]}
          required
          disabled={isDisabled}
        />
      </TableCell>
      }
      {
        !disableTarget && currentTarget === 'companycontract' && <TableCell size={'small'}>
          <ModelMenuSelectorField
            name='companycontract'
            model_name='companycontract'
            labelKeys={['name']}
            searchMode='search'
            config={{
              initial_filter: { company }
            }}
            loadOnMount
            selectFirst
            noneFirst
            noneLabel={I18n.t('all')}
            disabled={isDisabled}
          />
        </TableCell>
      }
      {
        !disableTarget && currentTarget === 'companyservice' && <TableCell size={'small'}>
          <ModelMenuSelectorField
            name='companyservice'
            model_name='companyservice'
            labelKeys={['name']}
            searchMode='search'
            config={{
              initial_filter: { contract: company }
            }}
            loadOnMount
            selectFirst
            noneFirst
            noneLabel={I18n.t('all')}
            disabled={isDisabled}
          />
        </TableCell>
      }
      {
        !disableTarget && currentTarget === 'companyuser' && <TableCell size={'small'}>
          <ModelMenuSelectorField
            name='companyuser'
            model_name='companyuser'
            searchMode='search'
            labelKeys={['label']}
            config={{
              initial_filter: { company },
              populate: ['user.customerinfo', 'contact'],
              mutator: companyuser => ({
                label: _.compact([companyuser?.contact?.first_name, companyuser?.contact?.last_name]).join(' ') || companyuser?.user?.customerinfo?.name,
                ...companyuser
              })
            }}
            loadOnMount
            selectFirst
            noneFirst
            noneLabel={I18n.t('all')}
            disabled={isDisabled}
          />
        </TableCell>
      }
    </>
  )
}
export default React.memo(Row)
